export default "__VITE_ASSET__5cd28467__"